import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  CreateJWTToken,
  CreateJWTTokenVariables,
} from './__generated__/useCreateJwtToken.graphql.ts';

const CREATE_JWT_TOKEN_MUTATION = gql`
  mutation CreateJWTToken($input: createJwtTokenInput!) {
    createJwtToken(input: $input) {
      jwtToken {
        expiredAt
        token
      }
    }
  }
` as TypedDocumentNode<CreateJWTToken, CreateJWTTokenVariables>;

export const useCreateJwtToken = () => {
  const [mutate] = useMutation(CREATE_JWT_TOKEN_MUTATION);

  return mutate;
};
